import { gql } from '@apollo/client';

export const GET_ALLOCATION_PLAN = gql`
  query GetAllocationPlan($id: ID!) {
    allocationPlan(id: $id) {
      id
      name
      allocations {
        token {
          id
          name
          ticker
          isDelisted
          coingeckoId
          coingeckoApiId
          coingeckoSlug
          groupId
          locationId
          group {
            id
            name
          }
          location {
            id
            name
          }
          marketData {
            currentPrice
            priceChange24h
            marketCap
          }
        }
        amount
        completed
        targetLocation {
          id
          name
        }
      }
      createdAt
      updatedAt
    }
  }
`;

export const GET_ALL_ALLOCATION_PLANS = gql`
  query GetAllAllocationPlans($portfolioId: ID!) {
    allAllocationPlans(portfolioId: $portfolioId) {
      id
      name
      allocations {
        token {
          id
          name
          ticker
          isDelisted
          coingeckoId
          coingeckoApiId
          coingeckoSlug
          groupId
          locationId
          group {
            id
            name
          }
          location {
            id
            name
          }
          marketData {
            currentPrice
            priceChange24h
            marketCap
          }
        }
        amount
        completed
        targetLocation {
          id
          name
        }
      }
      createdAt
      updatedAt
    }
  }
`; 